import * as React from 'react';
const SvgRadius = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M9.458 17.833v-1.275q-2.478-.226-4.134-1.882t-1.882-4.134H2.167a.53.53 0 0 1-.386-.155.52.52 0 0 1-.156-.383q0-.228.156-.387a.52.52 0 0 1 .386-.159h1.275q.226-2.478 1.882-4.145 1.655-1.665 4.134-1.87V2.166q0-.23.155-.386a.52.52 0 0 1 .383-.156q.228 0 .387.156a.52.52 0 0 1 .159.386v1.275q2.478.205 4.134 1.871t1.882 4.145h1.275q.23 0 .386.155.156.154.156.383a.53.53 0 0 1-.156.387.52.52 0 0 1-.386.159h-1.275q-.226 2.478-1.882 4.134t-4.134 1.882v1.275a.526.526 0 0 1-.538.542.53.53 0 0 1-.387-.156.52.52 0 0 1-.159-.386M10 15.5q2.292 0 3.896-1.604T15.5 10t-1.604-3.896T10 4.5 6.104 6.104 4.5 10t1.604 3.896Q7.71 15.5 10 15.5'
            />
        </g>
    </svg>
);
export default SvgRadius;
